import { createContext, useCallback, useContext, useEffect, useState } from "react";
import api, { brandingFileUrl } from "@/api";

const BrandingContext = createContext({ branding: null, refresh: () => {} });

export function BrandingProvider({ children }) {
  const [branding, setBranding] = useState(null);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/branding");
      setBranding(data);
    } catch {
      /* keep defaults */
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  useEffect(() => {
    if (!branding) return;
    if (branding.browser_title) document.title = branding.browser_title;
    if (branding.favicon_url) {
      let link = document.querySelector("link[rel~='icon']");
      if (!link) {
        link = document.createElement("link");
        link.rel = "icon";
        document.head.appendChild(link);
      }
      link.href = brandingFileUrl(branding.favicon_url);
    }
  }, [branding]);

  return <BrandingContext.Provider value={{ branding, refresh }}>{children}</BrandingContext.Provider>;
}

export const useBranding = () => useContext(BrandingContext);
